import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { H4 } from '../texts';
import { GridElement } from '../layout/GridElement';

import { SPACING_16, SPACING_8 } from '../../constants/spacing';

import { SpriteIconFunctional } from './SpriteIconFunctional';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  height: 100%;
  gap: ${SPACING_8};
`;

export const BackButton = (props) => {
  const { backOverrideUrl, onClick } = props;
  let navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <GridElement {...props}>
      <ContentWrapper
        onClick={() => {
          if (onClick) {
            onClick();
          } else {
            !backOverrideUrl ? navigate(-1) : navigate(backOverrideUrl);
          }
        }}
      >
        <SpriteIconFunctional
          id="Simple arrow"
          direction="Left"
          size={SPACING_16}
        />
        <H4>{t('app:globals:return')}</H4>
      </ContentWrapper>
    </GridElement>
  );
};
